import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseSelectComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_COUNTRY_INPUT_TYPE = 'postermywall-country-input';
const COUNTRY_OPTIONS = '<option value="placeholder" disabled selected>Select country</option>';

export const POSTERMYWALL_COUNTRY_INPUT: AddComponentTypeOptions = createBaseSelectComponent({
  inputFieldType: POSTERMYWALL_COUNTRY_INPUT_TYPE,
  inputName: 'country',
  dataMarkerAttribute: 'data-is-pmw-form-country-select',
  displayName: 'Country',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-country-select') !== null,
  defaultOptionsHtml: COUNTRY_OPTIONS,
});
